import React, { Component } from "react";
import AppHeader from "../../components/app-header";
import SearchPanel from "../search-panel";
import TaskStatusFilter from "../../components/task-status-filter";
import TasksList from "../../components/tasks-list";
import TaskAddForm from "../task-add-form";
import { declensionOfWord, generateId } from '../../helpers';
import "./app.css";
import styled from 'styled-components';
import { IMPORTANT, EDIT, COMPLETED } from '../../constants';
import TaskOnDeleteModal from "../task-on-delete-modal";

const AppBlock = styled.div`
	margin: 0 auto;
	max-width: 600px;
`
const SearchPanelWrap = styled.div`
	display: flex;
	align-items: center;
`
export default class App extends Component {
  state = {
    data: [
      { label: "Задача 1", important: false, completed: false, id: generateId() },
      { label: "Задача 2", important: false, completed: false, id: generateId() },
      { label: "Задача 3", important: false, completed: false, id: generateId() },
    ],
    term: '',
    filter: 'all',
    showModal: false,
    deleteTaskId: '',
  }

  componentDidMount() {
    if (!sessionStorage['tasks']) {

      this.setState(({ data }) => {
        //data validation-filtering
        const newData = data.filter(
          item =>
            item instanceof Object &&
            item &&
            item.id &&
            item.label &&
            item.hasOwnProperty("important") &&
            item.hasOwnProperty("completed")
        )
        return {
          data: newData
        }

      }, () => sessionStorage.setItem('tasks', JSON.stringify(this.state.data)))
    } else {
      this.setState({ data: JSON.parse(sessionStorage['tasks']) })
    }
  }

  addItem = body => {
    const newItem = {
      label: body,
      important: false,
      completed: false,
      id: generateId()
    }
    this.setState(({ data }) => {
      const updatedData = [...data, newItem]
      return {
        data: updatedData
      }
    }, () => sessionStorage.setItem('tasks', JSON.stringify(this.state.data)))
  }

  deleteItem = itemId => {
    this.setState(({ data }) => {
      const index = data.findIndex(({ id }) => id === itemId)

      const updatedData = [...data.slice(0, index), ...data.slice(index + 1)]

      return {
        data: updatedData,
        deleteTaskId: '',
        showModal: false
      }
    }, () => {
      if (sessionStorage['tasks']) {
        const storageTasks = JSON.parse(sessionStorage.getItem('tasks'))
          .filter(({ id }) => id !== itemId)

        sessionStorage.setItem('tasks', JSON.stringify(storageTasks))
      }
    })
  }

  onChangeTaskProp = (itemId, item, text) => {
    this.setState(({ data }) => {
      const index = data.findIndex(({ id }) => id === itemId)
      const old = data[index]
      let newItem = {}

      switch (item) {
        case COMPLETED:
          newItem = { ...old, completed: !old.completed }
          break
        case IMPORTANT:
          newItem = { ...old, important: !old.important }
          break
        case EDIT:
          newItem = { ...old, label: text }
          break
        default:
          break
      }

      const updatedData = [...data.slice(0, index), newItem, ...data.slice(index + 1)]

      return {
        data: updatedData
      }
    }, () => {
      if (sessionStorage['tasks']) {
        sessionStorage.setItem('tasks', JSON.stringify(this.state.data))
      }
    })
  }

  onToggleImportant = id => {
    this.onChangeTaskProp(id, IMPORTANT)
  }

  onToggleCompleted = id => {
    this.onChangeTaskProp(id, COMPLETED)
  }

  onEdit = (id, text) => {
    this.onChangeTaskProp(id, EDIT, text)
  }

  onToggleShowModal = () => {
    this.setState(({ showModal }) => {
      return {
        showModal: !showModal,
        deleteTaskId: ''
      }
    })
  }

  searchTask(items, term) {
    if (!term.length) {
      return items
    }
    return items.filter(({ label }) => label.toLowerCase().includes(term.toLowerCase()))
  }

  filterTask(items, filter) {
    switch (filter) {
      case COMPLETED:
        return items.filter(({ completed }) => completed)
      case IMPORTANT:
        return items.filter(({ important }) => important)
      default:
        return items
    }
  }

  onUpdateSearch = term => {
    this.setState({ term })
  }

  onFilterSelect = filter => {
    this.setState({ filter })
  }

  getDeleteTaskId = deleteTaskId => {
    this.setState({ deleteTaskId })
  }

  modalCloseHandler = () => {
    this.setState(({ modalShow }) => {
      return { modalShow: !modalShow }
    })
  }

  render() {
    const { term, filter, data, showModal, deleteTaskId } = this.state

    const completed = data.filter(({ completed }) => completed).length
    const allTasks = data.length
    const visibleTasks = this.filterTask(this.searchTask(data, term), filter)

    return (
      <>
        <AppBlock>
          <AppHeader
            completed={completed}
            allTasks={allTasks}
            tasksQuantity={declensionOfWord.bind(null, allTasks, ['задача', 'задачи', 'задач'])}
          />
          <SearchPanelWrap>
            <SearchPanel
              onUpdateSearch={this.onUpdateSearch}
            />
            <TaskStatusFilter
              filter={filter}
              onFilterSelect={this.onFilterSelect}
            />
          </SearchPanelWrap>
          <TasksList
            tasks={visibleTasks}
            getDeleteTaskId={this.getDeleteTaskId}
            onToggleImportant={this.onToggleImportant}
            onToggleCompleted={this.onToggleCompleted}
            onEdit={this.onEdit}
            onToggleShowModal={this.onToggleShowModal}
          />
          <TaskAddForm
            onAdd={this.addItem}
          />
        </AppBlock>

        {showModal &&
          (<TaskOnDeleteModal
            onToggleShowModal={this.onToggleShowModal}
            onDelete={this.deleteItem}
            deleteTaskId={deleteTaskId}
          />)}
      </>
    )
  }
}